// leaveTypeSlice.ts

import { createSlice } from '@reduxjs/toolkit';
import { LeaveTypeState } from './leaveTypeTypes';
import { createLeaveType, updateLeaveType, deleteLeaveType, fetchLeaveTypeById, fetchAllLeaveTypes } from './LeaveTypeActions';

// Initial state
const initialState: LeaveTypeState = {
    leaveTypes: [],
    selectedLeaveType: undefined,
    loadingStates: {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
};

// Slice
const leaveTypeSlice = createSlice({
    name: 'leaveTypes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Leave Type
            .addCase(createLeaveType.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createLeaveType.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.leaveTypes.push(action.payload);
            })
            .addCase(createLeaveType.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })

            // Update Leave Type
            .addCase(updateLeaveType.pending, (state) => {
                state.loadingStates.update = true;
                state.errors.update = undefined;
            })
            .addCase(updateLeaveType.fulfilled, (state, action) => {
                state.loadingStates.update = false;
                const index = state.leaveTypes.findIndex((leaveType) => leaveType.Id === action.payload.Id);
                if (index !== -1) {
                    state.leaveTypes[index] = action.payload;
                }
            })
            .addCase(updateLeaveType.rejected, (state, action) => {
                state.loadingStates.update = false;
                state.errors.update = action.payload as string;
            })

            // Delete Leave Type
            .addCase(deleteLeaveType.pending, (state) => {
                state.loadingStates.delete = true;
                state.errors.delete = undefined;
            })
            .addCase(deleteLeaveType.fulfilled, (state, action) => {
                state.loadingStates.delete = false;
                state.leaveTypes = state.leaveTypes.filter((leaveType) => leaveType.Id !== action.payload.Id);
            })
            .addCase(deleteLeaveType.rejected, (state, action) => {
                state.loadingStates.delete = false;
                state.errors.delete = action.payload as string;
            })

            // Fetch Leave Type by ID
            .addCase(fetchLeaveTypeById.pending, (state) => {
                state.loadingStates.fetchById = true;
                state.errors.fetchById = undefined;
            })
            .addCase(fetchLeaveTypeById.fulfilled, (state, action) => {
                state.loadingStates.fetchById = false;
                state.selectedLeaveType = action.payload;
            })
            .addCase(fetchLeaveTypeById.rejected, (state, action) => {
                state.loadingStates.fetchById = false;
                state.errors.fetchById = action.payload as string;
            })

            // Fetch All Leave Types
            .addCase(fetchAllLeaveTypes.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllLeaveTypes.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.leaveTypes = action.payload.data;
            })
            .addCase(fetchAllLeaveTypes.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            });
    },
});

export default leaveTypeSlice.reducer;
